/**
 * @desc 保存角色权限
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.RolePermissionRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/rolePermission/saveRolePermissions',
    data,
  });
}

export function mock(
  data: defs.RolePermissionRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/rolePermission/saveRolePermissions',
    data,
  });
}
